<template>
  <el-container>
    <el-main style="padding:0;width:100vh">
      <vm-table
          ref="vmTable"
          :filter.sync="filter"
          module="basic"
          url="sAPShipmentInvoices/getCustomerPriceStatistic601Detail">
        <template slot="adSearch">
          <div class="vm-search">
            <vm-search label="客户名称">
              <el-input v-model.trim="filter.customerName" clearable/>
            </vm-search>
            <vm-search label="排序">
              <el-select v-model="filter.orderType" clearable placeholder="请选择">
                <el-option label="客户" :value="1"/>
                <el-option label="金额" :value="2"/>
                <el-option label="库龄" :value="3"/>
              </el-select>
            </vm-search>
          </div>
        </template>
        <el-table-column prop="customerName" align="center" label="客户名称"/>
        <el-table-column prop="techParamBillNo" align="center" label="订单编号"/>
        <el-table-column prop="totalAmount" align="center" label="金额"/>
        <el-table-column prop="packingDate" align="center" label="包装时间"/>
        <el-table-column prop="storageAge" align="center" label="库龄"/>
      </vm-table>
    </el-main>
  </el-container>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";

  export default {
    name: "CustomerAmountSummaryDetailList",
    components: {VmTable,VmSearch},
    data() {
      return {
        filter: {
          customerName: "",
          orderType: null,
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
    },
  };
</script>

<style scoped>
</style>
